import React from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Content from '@common/content';
import Footer from '@common/footer';
import PstResults from '@components/phs/pst/results';
import ProfileTabWrap from '@components/profile/profileTabWrap';
import { ProfileTab } from '@domain/constant/ProfileTabType';

// 내 프로필 > 개발자 검사 결과 > 개발구현능력 검사
const PstResultsPage = () => {
  return (
    <Layout>
      <Header />
      <Content>
        <ProfileTabWrap profileTabType={ProfileTab.PHS_RESULTS}>
          <PstResults />
        </ProfileTabWrap>
      </Content>
      <Footer />
    </Layout>
  );
};

export default PstResultsPage;
